export default class ValidacionCedulaIt {
    constructor(
        public cedulaAfiliado?: string,
        public nombreAfiliado?: string,
        public fechaNacimientoAfiliado?: string,
        public rutaCedulaFrontal?: string,
        public rutaCedulaTrasera?: string
    ) {}
}

class ValidacionCedulaItResp {
    constructor(
        public cedulaCoincide?: boolean,
        public nombreCoincide?: boolean,
        public fechaNacimientoCoincide?: boolean,
    ) {}
}

export {ValidacionCedulaItResp}